import React, { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import Content from '../Content/Content';
import './About.css';
import Grid from '../Grid-View/Grid-View';
import rest from './stable.jpg';

var h1 = {
    marginBottom: '3em'
};
var margin = {
    marginBottom: '3em'
};
class About extends Component {
    render () {
        return (
            <Content pTop="72">
            <div style={margin}>
                <ScrollAnimation animateIn="fadeInDown" animateOnce="true">
                <h1 style={h1}>Willa Stara Wozownia</h1>
                </ScrollAnimation>
                <Grid strona="lewa" zdj={rest} sign={"fot. Matt Twardowowski"}>
                    <p>Kameralna atmosfera, designerski i oryginalny styl wnętrz to właśnie coś co wyróżnia Willę Stara Wozownia i sprawi że każda chwila spędzona w tym wyjątkowym miejscu będzie niezapomniana.<br/></p>
                    <p>Każde miejsce ma swoją historię.
Hotel powstał w domu wybudowanym w latach 80-tych XX wieku, który został zaadoptowany i zaprojektowany od nowa. Nietuzinkowy charakter wnętrz, inspracja pięknem koni tworzą niepowrarzalny klimat tego miejsca. W Willi Stara Wozownia, każdy pokój jest inny, każdy ma indywidualny wystrój i każdy został zaprojektowany tak, by czuć się w nim wyjątkowo. Nazwy pokoi to imiona koni, które wpisały się w historię polskiego jeździectwa, z dwóch największych polskich stadnin- Janowa Podlaskiego i Michałowa.</p>
            </Grid></div>
            </Content>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/About/About2.js